import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

interface PaginationState {
  page: number
  limit: number
  total: number
}

interface FilterState {
  [key: string]: any
}

interface ModalState {
  open: boolean
  data?: any
}

interface AppState {
  pagination: Record<string, PaginationState>
  filters: Record<string, FilterState>
  sorting: Record<string, { field: string; direction: 'asc' | 'desc' }>
  modals: Record<string, ModalState>
  loading: Record<string, boolean>
  errors: Record<string, string | null>
  selectedBranch: number | null
  selectedCenter: number | null
  showAllBranches: boolean
}

const initialState: AppState = {
  pagination: {},
  filters: {},
  sorting: {},
  modals: {},
  loading: {},
  errors: {},
  selectedBranch: null,
  selectedCenter: null,
  showAllBranches: false,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setPagination: (state, action: PayloadAction<{ key: string; pagination: PaginationState }>) => {
      state.pagination[action.payload.key] = action.payload.pagination
    },
    setFilters: (state, action: PayloadAction<{ key: string; filters: FilterState }>) => {
      state.filters[action.payload.key] = action.payload.filters
    },
    setSorting: (state, action: PayloadAction<{ key: string; sorting: { field: string; direction: 'asc' | 'desc' } }>) => {
      state.sorting[action.payload.key] = action.payload.sorting
    },
    openModal: (state, action: PayloadAction<{ key: string; data?: any }>) => {
      state.modals[action.payload.key] = { open: true, data: action.payload.data }
    },
    closeModal: (state, action: PayloadAction<string>) => {
      const key = action.payload
      state.modals[key] = { open: false }
    },
    setLoading: (state, action: PayloadAction<{ key: string; loading: boolean }>) => {
      state.loading[action.payload.key] = action.payload.loading
    },
    setError: (state, action: PayloadAction<{ key: string; error: string | null }>) => {
      state.errors[action.payload.key] = action.payload.error
    },
    setSelectedBranch: (state, action: PayloadAction<number | null>) => {
      state.selectedBranch = action.payload
    },
    setSelectedCenter: (state, action: PayloadAction<number | null>) => {
      state.selectedCenter = action.payload
    },
    setShowAllBranches: (state, action: PayloadAction<boolean>) => {
      state.showAllBranches = action.payload
    },
  },
})

export const {
  setPagination,
  setFilters,
  setSorting,
  openModal,
  closeModal,
  setLoading,
  setError,
  setSelectedBranch,
  setSelectedCenter,
  setShowAllBranches,
} = appSlice.actions

export default appSlice.reducer
